var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel-header',[_c('v-badge',{attrs:{"left":"","color":"error","content":_vm.tabErrors[_vm.name],"value":_vm.tabErrors[_vm.name] > 0}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }